import styled, { css } from "styled-components";
import tw from "twin.macro";

import { BoxSizingStyle } from "../BoxSizingStyle";
import { FontStyle } from "../FontStyle";
import { InputMode } from "../Input/types";

interface StyledTextareaProps {
  disabled: boolean;
  $invalid: boolean;
  $mode: InputMode;
}

export const StyledTextarea = styled.textarea<StyledTextareaProps>`
  ${tw`tw-text-body-2`}
  ${tw`tw-text-theme-900`}
  ${tw`tw-leading-regular`}
  ${tw`tw-tracking-regular`}
  ${tw`tw-font-regular`}
  border-width: 1px;
  border-style: solid;
  background-color: var(--input-background-color);
  ${tw`tw-border-theme-500`}
  border-radius: 8px;
  padding: 4px 8px 6px 8px;
  height: auto;
  transition: all 0.3s ease;
  width: 360px;
  min-height: 90px;
  outline: none;
  ${FontStyle}
  ${BoxSizingStyle}

  ${(props) =>
    props.$mode === "flat" &&
    css`
      border: none;
      background-color: transparent;
    `}

  ${(props) =>
    props.disabled &&
    css`
      ${tw`tw-cursor-not-allowed tw-opacity-50`}
    `}

  ${(props) =>
    !props.disabled &&
    !props.$invalid &&
    props.$mode === "outlined" &&
    css`
      &:active,
      &:focus,
      &:hover {
        ${tw`tw-border-primary`}
      }
    `}

  &::placeholder {
    ${tw`tw-text-theme-transparent-500`}
  }

  ${(props) =>
    !props.disabled &&
    props.$invalid &&
    props.$mode === "outlined" &&
    css`
      ${tw`tw-border-alert`}
    `}

  ${(props) =>
    !props.disabled &&
    props.$invalid &&
    props.$mode === "flat" &&
    css`
      color: var(--red-alert);
    `}
`;

StyledTextarea.displayName = "StyledTextarea";
